import { render, staticRenderFns } from "./agv-rules.vue?vue&type=template&id=648d4342&scoped=true&lang=pug&"
import script from "./agv-rules.vue?vue&type=script&lang=js&"
export * from "./agv-rules.vue?vue&type=script&lang=js&"
import style0 from "./agv-rules.vue?vue&type=style&index=0&id=648d4342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d4342",
  null
  
)

export default component.exports